import { createAction } from '@reduxjs/toolkit';

export const resetStateAction = createAction('resetState');
